import './AvatarPreview.scss'
import React, { Component } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { channelStore } from '../../app/stores'
import { AVATAR_CONFIG } from '../../app/constants'
import { Button, UserAvatar, TeamIcon, Icon } from '../../lib'

class AvatarPreview extends Component {
  constructor (props) {
    super(props)
    this.handleRefresh = this.handleRefresh.bind(this)
    this.state = { refreshed: false }
  }

  handleRefresh (e) {
    e.preventDefault()
    this.setState({ refreshed: true })
    channelStore.refreshAvatar(this.props.config)
  }

  render () {
    const refreshing = channelStore.refreshingAvatar
    const className = classnames('AvatarPreview', {
      'AvatarPreview-refreshed': this.state.refreshed
    })
    return (
      <div className={className}>
        <div className='AvatarPreview_image'>
          {this.props.config === AVATAR_CONFIG.USER ? (
            <UserAvatar />
          ) : (
            <TeamIcon />
          )}
          {refreshing && (
            <Icon
              name='loading'
              color='white'
              size={12}
              spin
            />
          )}
        </div>
        <Button onClick={this.handleRefresh} disabled={refreshing}>
          <span>
            Refresh
          </span>
        </Button>
      </div>
    )
  }
}

AvatarPreview.displayName = 'AvatarPreview'

export default observer(AvatarPreview)



// WEBPACK FOOTER //
// ./src/channel/behavior/AvatarPreview.js